namespace $ {

	/** Browser-local credentials. Reading the login menu must not load the CRDT profile. */
	export type $shm_hitalama_account_local_entry = { id: string, name: string, profile: string, auth: string }

	export class $shm_hitalama_account_local extends $mol_object {

		@ $mol_mem
		static current() { return new this }

		items() {
			const saved = this.$.$mol_state_local.value< $shm_hitalama_account_local_entry[] >( 'hitalama_profiles' )
			return Array.isArray( saved ) ? saved.filter( item => item && [ item.id, item.name, item.profile, item.auth ].every( value => typeof value === 'string' && value.length > 0 ) ) : []
		}

		auth( id: string ) {
			const entry = this.items().find( item => item.id === id )
			if( !entry ) throw new Error( 'Сохранённый аккаунт не найден.' )
			const auth = this.$.$mol_error_fence(
				()=> this.$.$giper_baza_auth.from( entry.auth ),
				()=> { throw new Error( 'Не удалось прочитать ключ сохранённого аккаунта.' ) },
			)
			if( auth.byteLength !== 128 || auth.pass().lord().str !== entry.id ) throw new Error( 'Не удалось прочитать ключ сохранённого аккаунта.' )
			return auth
		}

	}

}
